module.exports = __webpack_public_path__ + "img/logo.4b2bbf7d.png";